import { Col, Form, Row } from "react-bootstrap";

const SecondStepMobile = ({secondStep, updateMultipleValues}) => {

    const handleChangeRadio = (e) => {
        const values = {...secondStep};
        values[e.target.id] = parseInt(e.target.value);
        console.log(e.target.id, e.target.value);
        updateMultipleValues({secondStep: values});
    }
    return (
      <>
        <div className="d-flex flex-column  position-relative" onChange={(e) => handleChangeRadio(e)}>
        
            <h1 className="register-text" style={{fontSize: 24, marginBottom: 15}}>General impression of the course</h1>
            {/* <div className="d-flex  align-items-end"> */}
            <Row style={{background: "rgba(217, 217, 217, 1)", color: "black", marginRight: 0, marginLeft: 0}}>
                <Col xs={3}><div className="form-label-mobile" style={{textAlign: "center"}}>Strongly disagree</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Disagree</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Neutral</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Agree</div>
                </Col>
                <Col xs={3}><div className="form-label-mobile" style={{textAlign: "center"}}>Strongly agree</div>
                </Col>
            </Row>
            <Form>
                <Form.Group>
                    <Row style={{marginTop: 20, marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_quality`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_quality === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_quality`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_quality === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_quality`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_quality === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_quality`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_quality === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_quality`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_quality === 5}
                                />
                        </Col>
                        
                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The overall quality of the course was sufficient *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_organisation`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_organisation === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_organisation`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_organisation === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_organisation`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_organisation === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_organisation`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_organisation === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_organisation`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_organisation === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The course was well organized *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_prerequisites`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_prerequisites === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_prerequisites`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_prerequisites === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_prerequisites`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_prerequisites === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_prerequisites`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_prerequisites === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_prerequisites`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_prerequisites === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The course subject matter was adapted to my prior knowledge *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_clear_objectives`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_clear_objectives === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_clear_objectives`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_clear_objectives === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_clear_objectives`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_clear_objectives === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_clear_objectives`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_clear_objectives === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_clear_objectives`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_clear_objectives === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The course objectives were clear to me *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_topic_relevance`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_topic_relevance === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_topic_relevance`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_topic_relevance === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_topic_relevance`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_topic_relevance === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_topic_relevance`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_topic_relevance === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_topic_relevance`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_topic_relevance === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The relevance of the topics of this course within the context of my field of study was clear to me *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_online_tools`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_online_tools === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_online_tools`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_online_tools === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_online_tools`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_online_tools === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_online_tools`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_online_tools === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_online_tools`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={secondStep?.course_online_tools === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The learning management system was clearly structured *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
      </div>
      </>
    );
  };
  
  export default SecondStepMobile;
  